var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSandWatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5026 10.0003L6.94177 7.03366C6.4126 6.59199 6.14844 6.37199 5.95844 6.10116C5.78985 5.8618 5.66461 5.59468 5.58844 5.31199C5.5026 4.99283 5.5026 4.64866 5.5026 3.96033V1.66699M10.5026 10.0003L14.0634 7.03366C14.5926 6.59199 14.8568 6.37199 15.0468 6.10116C15.2154 5.8618 15.3406 5.59468 15.4168 5.31199C15.5026 4.99283 15.5026 4.64866 15.5026 3.96033V1.66699M10.5026 10.0003L6.94177 12.967C6.4126 13.4087 6.14844 13.6287 5.95844 13.8995C5.78985 14.1389 5.66461 14.406 5.58844 14.6887C5.5026 15.0078 5.5026 15.352 5.5026 16.0403V18.3337M10.5026 10.0003L14.0634 12.967C14.5926 13.4087 14.8568 13.6287 15.0468 13.8995C15.2154 14.1389 15.3406 14.406 15.4168 14.6887C15.5026 15.0078 15.5026 15.352 15.5026 16.0403V18.3337M3.83594 1.66699H17.1693M3.83594 18.3337H17.1693",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandWatch);
export default __webpack_public_path__ + "static/media/sandWatch.af073e7cdff669c45ffba08d663a1371.svg";
export { ForwardRef as ReactComponent };